import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function DemoReadonlyModal() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  // Show when a write is blocked
  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("demo-readonly-blocked", handler);
    return () => window.removeEventListener("demo-readonly-blocked", handler);
  }, []);

  if (!visible) return null;

  return (
    <div style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)",
      zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center",
    }}>
      <div style={{
        background: "var(--bg-card)", borderRadius: "12px", padding: "2rem",
        maxWidth: "380px", width: "90%", textAlign: "center",
        boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
        border: "2px solid #f59e0b",
      }}>
        <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>🔒</div>
        <h3 style={{ margin: "0 0 0.75rem", color: "var(--text-primary)" }}>Demo Mode — Read Only</h3>
        <p style={{ margin: "0 0 1.25rem", color: "var(--text-muted)", fontSize: "0.95rem", lineHeight: 1.5 }}>
          This is a live demo of a real collection. Changes to data and settings are not permitted in demo mode.
        </p>
        <p style={{ margin: "0 0 1.5rem", color: "var(--text-muted)", fontSize: "0.9rem" }}>
          Sign up for free to start tracking your own collection.
        </p>
        <div style={{ display: "flex", gap: "0.75rem", justifyContent: "center" }}>
          <button
            className="nav-btn"
            style={{ background: "#1a7a1a" }}
            onClick={() => { setVisible(false); navigate("/register"); }}
          >
            Sign Up Free
          </button>
          <button
            className="nav-btn"
            style={{ background: "var(--bg-muted)", color: "var(--text-primary)" }}
            onClick={() => setVisible(false)}
          >
            Continue Browsing
          </button>
        </div>
      </div>
    </div>
  );
}
